import React, { useState, useEffect } from 'react';

function Sidebar({ API_URL, token, medecin, convActive, sidebarOpen, refresh, onFermer, onLogout, onOuvrirConv, onNouvelleConsultation, onListePatients }) {
    const [conversations, setConversations] = useState([]);
    const [recherche, setRecherche]         = useState('');

    useEffect(() => {
        if (token) chargerConversations();
    }, [token, refresh]);

    async function chargerConversations(rech = '') {
        const url = rech
            ? `${API_URL}/conversations?recherche=${encodeURIComponent(rech)}`
            : `${API_URL}/conversations`;
        const res  = await fetch(url, { headers: { Authorization: `Bearer ${token}`, "ngrok-skip-browser-warning": "true" } });
        const data = await res.json();
        setConversations(data);
    }

    async function supprimerConversation(e, convId) {
        e.stopPropagation();
        // eslint-disable-next-line no-restricted-globals
        if (!confirm('Supprimer cette consultation ?')) return;
        await fetch(`${API_URL}/conversations/${convId}`, {
            method : 'DELETE',
            headers: { Authorization: `Bearer ${token}`, "ngrok-skip-browser-warning": "true" }
        });
        chargerConversations(recherche);
    }

    return (
            <div className = {sidebarOpen ? 'sidebar-desktop open' : 'sidebar-desktop'} 
            style={{
                width        : '260px',
                minWidth     : '260px',
                maxWidth     : '260px',
                background   : 'var(--bg-light)',
                borderRight  : '1px solid var(--border)',
                display      : 'flex',
                flexDirection: 'column',
                height       : '100vh',
                overflow     : 'hidden',
                transition   : 'transform 0.3s ease'
            }}>

            {/* Top */}
            <div style={{ padding: '20px 16px 16px', borderBottom: '1px solid var(--border)', flexShrink: 0 }}>
                <div style={{ fontSize: '15px', fontWeight: 600, color: 'var(--white)', marginBottom: '16px' }}>
                    Agent Médical
                </div>

                {/* Bouton liste patients */}
                <button
                    onClick = {onListePatients}
                    style={{
                        width: '100%', padding: '9px 14px',
                        background: 'transparent', border: '1px solid var(--border)',
                        borderRadius: '8px', color: 'var(--text)',
                        fontSize: '13px', cursor: 'pointer',
                        textAlign: 'left', display: 'flex',
                        alignItems: 'center', gap: '8px', marginBottom: '8px'
                    }}
                >
                    <span>👥</span> Liste des patients
                </button>

                {/* Bouton nouvelle consultation */}
                <button
                    onClick = {onNouvelleConsultation}
                    style={{
                        width: '100%', padding: '9px 14px',
                        background: 'transparent', border: '1px solid var(--border)',
                        borderRadius: '8px', color: 'var(--text)',
                        fontSize: '13px', cursor: 'pointer',
                        textAlign: 'left', display: 'flex',
                        alignItems: 'center', gap: '8px'
                    }}
                >
                    <span>+</span> Nouvelle consultation
                </button>
            </div>

            {/* Recherche */}
            <div style={{ padding: '12px 16px', borderBottom: '1px solid var(--border)', flexShrink: 0 }}>
                <input
                    type        = "text"
                    value       = {recherche}
                    placeholder = "Rechercher un patient..."
                    onChange    = {e => {
                        setRecherche(e.target.value);
                        chargerConversations(e.target.value);
                    }}
                    style={{
                        width: '100%', padding: '8px 12px',
                        background: 'var(--bg)', border: '1px solid var(--border)',
                        borderRadius: '8px', color: 'var(--text)',
                        fontSize: '13px', outline: 'none'
                    }}
                />
            </div>

            {/* Liste conversations */}
            <div style={{ flex: 1, overflowY: 'auto', padding: '8px', minHeight: 0 }}>
                {conversations.length === 0 ? (
                    <div style={{ color: '#555', fontSize: '13px', padding: '20px', textAlign: 'center' }}>
                        Aucune consultation
                    </div>
                ) : (
                    conversations.map(conv => {
                        const dateStr = new Date(conv.created_at).toLocaleString('fr-FR', {
                            day: '2-digit', month: '2-digit', year: 'numeric',
                            hour: '2-digit', minute: '2-digit'
                        });
                        const infoStr = [
                            conv.age  ? `${conv.age} ans` : '',
                            conv.sexe === 'M' ? '♂' : conv.sexe === 'F' ? '♀' : ''
                        ].filter(Boolean).join(' · ');

                        return (
                            <div
                                key     = {conv.id}
                                onClick = {() => onOuvrirConv(conv.id, {
                                    id        : conv.patient_id,
                                    nom       : conv.nom_patient,
                                    age       : conv.age,
                                    sexe      : conv.sexe,
                                    telephone : conv.telephone
                                })}
                                style={{
                                    padding        : '10px 12px',
                                    borderRadius   : '8px',
                                    cursor         : 'pointer',
                                    marginBottom   : '2px',
                                    display        : 'flex',
                                    alignItems     : 'center',
                                    justifyContent : 'space-between',
                                    background     : convActive === conv.id ? 'var(--bg-hover)' : 'transparent',
                                    color          : convActive === conv.id ? 'var(--text)' : 'var(--text-muted)'
                                }}
                            >
                                <div style={{ flex: 1, minWidth: 0 }}>
                                    <div style={{ fontSize: '13px', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                                        {conv.nom_patient} — {dateStr}
                                    </div>
                                    {infoStr && (
                                        <div style={{ fontSize: '11px', color: 'var(--text-muted)', marginTop: '2px' }}>
                                            {infoStr}
                                        </div>
                                    )}
                                </div>
                                <button
                                    onClick     = {e => supprimerConversation(e, conv.id)}
                                    style={{
                                        background : 'none', border   : 'none',
                                        color      : 'transparent', cursor  : 'pointer',
                                        padding    : '2px 4px', fontSize : '13px', flexShrink: 0
                                    }}
                                    onMouseOver = {e => e.target.style.color = '#e06c6c'}
                                    onMouseOut  = {e => e.target.style.color = 'transparent'}
                                >✕</button>
                            </div>
                        );
                    })
                )}
            </div>

            {/* Footer */}
            <div style={{
                padding        : '14px 16px',
                borderTop      : '1px solid var(--border)',
                display        : 'flex',
                alignItems     : 'center',
                justifyContent : 'space-between',
                flexShrink     : 0,
                gap            : '8px'
            }}>
                <span style={{ fontSize: '13px', color: 'var(--text-muted)', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                    Dr. {medecin}
                </span>
                <button
                    onClick     = {onLogout}
                    style={{
                        background   : 'none', border      : 'none',
                        color        : 'var(--text-muted)', fontSize    : '12px',
                        cursor       : 'pointer', padding     : '4px 8px',
                        borderRadius : '6px', whiteSpace  : 'nowrap'
                    }}
                    onMouseOver = {e => e.target.style.color = '#e06c6c'}
                    onMouseOut  = {e => e.target.style.color = 'var(--text-muted)'}
                >
                    Déconnexion
                </button>
            </div>
        </div>
    );
}

export default Sidebar;